<template>
  <v-container
    id="locationSummary"
  >
    <v-progress-linear
      v-show="loading"
      indeterminate
      color="green"
    />
    <div>
      <div class="oe-summary-title">
        <v-btn
          class="mx-2"
          fab
          dark
          x-small
          :color="approvals.color"
          @click="displaySection = !displaySection"
        >
          <v-icon
            v-show="!displaySection"
            dark
          >
            mdi-arrow-expand-vertical
          </v-icon>
          <v-icon
            v-show="displaySection"
            dark
          >
            mdi-arrow-expand-horizontal
          </v-icon>
        </v-btn>
        Location Summary
      </div>
      <v-fab-transition>
        <note
          v-show="displaySection"
          :open-enrollment="openEnrollment"
          :section="sections.location"
          summary="true"
        />
      </v-fab-transition>
      <v-container
        v-if="!loading && locations && locations.length"
        fluid
      >
        <v-row dense>
          <v-col
            v-for="(location, i) in locations"
            :key="i"
          >
            <v-fab-transition>
              <v-card
                v-show="displaySection"
                class="location-summary"
              >
                <v-card-text>
                  <div class="display-2 text--primary">
                    <span v-text="location.locationName" />
                  </div>
                  <div
                    class="display-1 text--primary"
                  >
                    <span v-text="location.locationAddress" />
                  </div>
                  <div
                    class="display-1 text--primary"
                  >
                    <span v-text="location.locationCity" />,
                    <span v-text="location.locationState" />
                    <span v-text="location.locationZip" />
                    <ul
                      v-for="(jobClass, j) in jobClassesByLocation(location)"
                      :key="j"
                    >
                      <li>
                        {{ jobClass.jobClassName }}
                      </li>
                    </ul>
                  </div>
                </v-card-text>
              </v-card>
            </v-fab-transition>
          </v-col>
        </v-row>
      </v-container>
      <v-fab-transition>
        <v-alert
          v-show="displaySection && (!loading && (!locations || !locations.length))"
          type="info"
        >
          No location details found
        </v-alert>
      </v-fab-transition>
      <v-fab-transition>
        <approval
          v-show="displaySection"
          :approvals="approvals"
          :allow-change="!print"
          @approval:changed="$emit('approval:changed')"
        />
      </v-fab-transition>
    </div>
    <base-material-snackbar
      v-model="displayError"
      type="error"
      v-bind="{
        top: true,
        right: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'
  import Approvals from '@/services/troody/Approvals'

  export default {
    name: 'LocationSummary',

    components: {
      Note: () => import('./Note'),
      Approval: () => import('./Approval'),
    },

    props: {
      expanded: {
        type: Boolean,
        default: false,
      },
      openEnrollment: {
        type: Object,
        default: null,
      },
      print: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      displaySection: true,
      loadingLocations: false,
      loadingJobClasses: false,

      errorMessage: null,
      displayError: false,
      formErrors: {},

      locations: null,
      jobClasses: null,

      locationResource: new TroodyApi('oeLocation/'),
      jobClassResource: new TroodyApi('oeLocationOEJobClass/'),
      approvals: null,
    }),

    computed: {
      loading () {
        return (this.loadingLocations || this.loadingJobClasses)
      },

      sections () {
        return Approvals.sections
      },
    },

    watch: {
      expanded (val) {
        this.displaySection = val
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.formErrors = {}
        this.loadLocations()
        this.loadJobClasses()
        this.approvals = new Approvals(this.openEnrollment.id, Approvals.sections.location.id)
        this.displaySection = this.expanded
      },

      jobClassesByLocation (location) {
        let classes = []

        if (this.jobClasses && this.jobClasses.length) {
          classes = this.jobClasses.filter((item) => {
            return item.oeLocationId === location.id
          })
        }

        return classes
      },

      loadLocations () {
        this.loadingLocations = true
        this.locationResource.query({ openEnrollmentId: this.openEnrollment.id })
          .then(data => {
            this.loadingLocations = false
            this.locations = data
          })
          .catch((error) => {
            this.loadingLocations = false
            this.locations = null
            this.showError(error, 'Failed to load location details!')
          })
      },

      loadJobClasses () {
        this.loadingJobClasses = true
        this.jobClassResource.query({ openEnrollmentId: this.openEnrollment.id })
          .then(data => {
            this.loadingJobClasses = false
            this.jobClasses = data
          })
          .catch((error) => {
            this.loadingJobClasses = false
            this.jobClasses = null
            this.showError(error, 'Failed to load location job class details!')
          })
      },

      showError (error, msg) {
        console.log(error)
        this.errorMessage = (error || msg)
        this.displayError = true
      },
    },
  }
</script>

<style lang="sass">
  .location-summary
    border-width: 3px
    border-style: solid
    border-color: rgba(0, 255, 0, 0.1) !important
    border-radius: 10px !important
    margin: 4px !important
</style>
